import { atom } from "recoil";

export const currentUserTimeout = atom({
  key: "currentUserTimeout",
  default: {},
});